function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 1.98242,
  y1: 1,
  x2: 23.934,
  y2: 1,
  stroke: "#2E0A63",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1.98242,
  y1: 8,
  x2: 23.934,
  y2: 8,
  stroke: "#2E0A63",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 1.98242,
  y1: 15,
  x2: 23.934,
  y2: 15,
  stroke: "#2E0A63",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.94875fdc.svg";
export { ForwardRef as ReactComponent };